<script>
  import Ribbons from "../Modals/badgeRibbons/index.svelte"
  import Shapes from "../Modals/badgeShapes/index.svelte"
  import BadgeState from "../../Stores/badgeState"
  import AddFontToList from "../../../File/Edit/modules/addFontToList/index.svelte"
  import CustomFont from "../../../File/Edit/modules/customFont/index.svelte"
  import defaultFonts from "../../../File/stores/fileTemplateDefaultFonts"
  import WindowDetailsModal from "../../../File/Edit/Components/windowDetailsModal.svelte"
  import GoBackModal from "../Modals/goBackModal/index.svelte"
  import fileTemplateState from "../../../File/stores/fileTemplateJsonData"
  import notify from "../../../../../Script/notify"
  import { push } from "svelte-spa-router"
  import { loadImage, drawChecked } from "../../../File/Edit/Script/loadImg"
  export let baseCanvas
  export let initialData
  let bgShapes = false
  let bgRibbon = false
  let showWindowDetails = false

  let closeNotification = {
    close() {},
  }

  const addTextLayer = () => {
    let textJsonData = {
      id: Date.now(),
      active: true,
      type: "text",
      fontSize: $fileTemplateState.activeFontSize || 40,
      fontFamily: $fileTemplateState.activeFontFamily || "Arial",
      fontWeight: $BadgeState.activeFontStyles || [],
      value: "",
      // offset: 45,
      letterSpacing: 30,
      move: false,
      radius: 0,
      textColor: $BadgeState.activeTextColor || "#f2072e",
      textAlign: $BadgeState.activeTextAlign || "center",
      x: Math.floor($BadgeState.baseInfo.width / 2),
      y: Math.floor($BadgeState.baseInfo.height / 2),
      isRounded: false,
      rotation: 0,
    }

    // active false applied before layer
    $BadgeState.operations.forEach((operation) => {
      operation.active = false
      operation.textColor ? operation.textColor : "#f2072e"
    })

    textJsonData.value = `Text ${$BadgeState.operations.length + 1}`
    $BadgeState.operations = [textJsonData, ...$BadgeState.operations]
    $BadgeState.footer = "TEXT"
  }

  const addImageLayer = async () => {
    // $BadgeState.operations.forEach((operation) => {
    //   operation.textColor ? operation.textColor : "#f2072e"
    // })
    let size = Math.floor($BadgeState.baseInfo.width / 5)
    let checkedImage = drawChecked(size, size)
    let imageJsonData = {
      id: Date.now(),
      active: true,
      src: checkedImage,
      image: await loadImage(checkedImage),
      type: "image",
      value: "",
      move: false,
      width: size,
      height: size,
      x: Math.floor($BadgeState.baseInfo.width / 2),
      y: Math.floor($BadgeState.baseInfo.height / 2),
      // x: Math.floor(($BadgeState.baseInfo.width * 0.9) / 2),
      // y: Math.floor(($BadgeState.baseInfo.height * 0.9) / 2),
      uploadImage: true,
      rotation: 0,
    }

    // active false applied before layer
    $BadgeState.operations.forEach((operation) => {
      operation.active = false
    })

    imageJsonData.value = `Image ${$BadgeState.operations.length + 1}`
    $BadgeState.operations = [imageJsonData, ...$BadgeState.operations]
    $BadgeState.footer = "IMAGE"
  }

  const handleBackOperations = () => {
    closeNotification.close()
    try {
      $BadgeState.name = $BadgeState.name.trim()
      if (!$BadgeState.name) throw "Badge template name can't be empty"

      let isChanged = compareObj(initialData, $BadgeState)
      if (isChanged) $BadgeState.goBack = true
      else push("/templates/badge")
    } catch (error) {
      console.error(error)
      const info = "PAGE: Badge Template Editor (Navbar)\nEVENT: While moving back"
      closeNotification = notify.danger(error, info)
    }
  }

  const compareObj = (initial, latest) => {
    try {
      if (initial.name != latest.name) return true
      if (initial.canvasColor != latest.canvasColor) return true
      if (JSON.stringify(initial.baseInfo) != JSON.stringify(latest.baseInfo)) return true
      if (initial.operations.length != latest.operations.length) return true
      if (initial.operations.length == latest.operations.length) {
        for (let i = 0; i < initial.operations.length; i++) {
          if (JSON.stringify(initial.operations[i]) != JSON.stringify(latest.operations[i])) return true
        }
      }

      return false
    } catch (error) {
      throw error
    }
  }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div data-tooltip="Back" tooltip-position="right" on:click={handleBackOperations} class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md p-2 text-center text-white hover:bg-black hover:text-blue-500">
  <i class="fa-solid fa-backward" />
</div>
<div class="space-y-5">
  <!-- svelte-ignore a11y-click-events-have-key-events -->

  <div
    data-tooltip="Shapes"
    tooltip-position="right"
    on:click={() => {
      bgShapes = true
    }}
    class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md p-2 text-center text-white hover:bg-black hover:text-blue-500"
  >
    <i class="fa-solid fa-shapes" />
  </div>
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div
    on:click={() => {
      bgRibbon = true
    }}
    data-tooltip="Ribbon"
    tooltip-position="right"
    class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md p-2 text-center text-white hover:bg-black hover:text-blue-500"
  >
    <i class="fa-solid fa-ribbon" />
  </div>
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div on:click={addTextLayer} data-tooltip="Text" tooltip-position="right" class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md p-2 text-center text-white hover:bg-black hover:text-blue-500">
    <i class="fa-solid fa-text" />
  </div>
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div on:click={addImageLayer} data-tooltip="Image" tooltip-position="right" class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md p-2 text-center text-white hover:bg-black hover:text-blue-500">
    <i class="fa-solid fa-image" />
  </div>

  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div
    on:click={() => {
      $defaultFonts.newFontListModal = true
    }}
    data-tooltip="Add Font"
    tooltip-position="right"
    class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md p-2 text-center text-white hover:bg-black hover:text-blue-500"
  >
    <i class="fa-solid fa-a" />
  </div>
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div
    on:click={() => {
      $BadgeState.download = true
    }}
    data-tooltip="Download"
    tooltip-position="right"
    class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md p-2 text-center text-white hover:bg-black hover:text-blue-500"
  >
    <i class="fa-solid fa-download" />
  </div>
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div
    data-tooltip="Reset Pan and Zoom"
    on:click={() => {
      $BadgeState.scale = 1
    }}
    tooltip-position="right"
    class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md p-2 text-center text-white hover:bg-black hover:text-blue-500"
  >
    <i class="fa-solid fa-rotate-right" />
  </div>
</div>
<div class="space-y-5">
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div
    on:click={() => {
      showWindowDetails = true
    }}
    data-tooltip="Made with &#128150 by docChain"
    tooltip-position="right"
  >
    <button class="flex h-10 w-10 items-center justify-center rounded-md hover:animate-rotate">
      <svg id="Layer_2" height="25" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 727.6 594.77">
        <defs>
          <style>
            .cls-1 {
              fill: #ff6a00;
            }
          </style>
        </defs>
        <g id="Layer_1-2" data-name="Layer 1">
          <g>
            <path class="cls-1" d="m363.8,250.05l-229.9,109.87,229.9,109.88v124.97L55.03,447.21c-73.38-35.07-73.38-139.52,0-174.59L363.8,125.03v125.02Z" />
            <path class="cls-1" d="m363.8,125.02l229.9,109.87-229.9,109.88v124.97l308.76-147.56c73.38-35.07,73.38-139.52,0-174.59L363.8,0v125.02Z" />
          </g>
        </g>
      </svg>
    </button>
  </div>
</div>

{#if bgShapes}
  <Shapes
    bind:bgShapes
    on:click={() => {
      bgShapes = false
    }}
  />
{/if}
{#if bgRibbon}
  <Ribbons
    bind:bgRibbon
    on:click={() => {
      bgRibbon = false
    }}
  />
{/if}

{#if $defaultFonts.newFontListModal}
  <AddFontToList bind:tempState={$BadgeState} />
{/if}

{#if $defaultFonts.addCustomFont}
  <CustomFont />
{/if}
{#if showWindowDetails}
  <div class="z-50 text-left">
    <WindowDetailsModal
      on:click={() => {
        showWindowDetails = false
      }}
    />
  </div>
{/if}

{#if $BadgeState.goBack}
  <GoBackModal {baseCanvas} />
{/if}
